import React from 'react'
import theme from '../../theme'

interface IProps {
  isDestination?: boolean
  outsideArea?: boolean
  flying?: boolean
}

// Vector twin of mobile's pin-location/pin-fly assets, which only ship at 1x
// and blur on retina. Geometry and colours are taken from those PNGs.
export const MapPin: React.FC<IProps> = ({ isDestination, outsideArea, flying }) => {
  const color = isDestination ? theme.colors.greenRadio : theme.colors.accent
  const tint = isDestination ? theme.colors.lightGreen : theme.colors.accentLight

  // Head circle of r=16.5 at (17.5, 16.5) with sides running tangent to a tip.
  const body = 'M17.5 42.5 L4.75 26.98 A16.5 16.5 0 1 1 30.25 26.98 Z'

  const mark = outsideArea
    ? (
        <g stroke={ tint } strokeWidth="2" fill="none">
          <circle cx="17.5" cy="16.5" r="6" />
          <line x1="13.2" y1="12.2" x2="21.8" y2="20.8" />
        </g>
      )
    : <circle cx="17.5" cy="16.5" r="4" fill={ theme.colors.white } />

  if (flying) {
    return (
      <svg width="35" height="56" viewBox="0 0 35 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d={ body } fill={ color } />
        { mark }
        <circle cx="17.5" cy="50.5" r="4.5" fill={ color } />
      </svg>
    )
  }

  return (
    <svg width="35" height="49" viewBox="0 0 35 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="17.5" cy="44" rx="12.5" ry="4.6" fill={ color } />
      <ellipse cx="17.5" cy="44" rx="8.2" ry="2.6" fill={ tint } />
      <path d={ body } fill={ color } />
      { mark }
    </svg>
  )
}
